'use strict';

class Media {
  constructor(data, $wrapperEl, autoSlideShow) {
    this.data = data;
    this.$el = $wrapperEl.find(`[data-id="${data.id}"]`);
    this.$wrapperEl = $wrapperEl;
    this.autoSlideShow = autoSlideShow;
    this.onPlayerReady = this.onPlayerReady.bind(this);
    this.onPlayerStateChange = this.onPlayerStateChange.bind(this);
  }

  getId() {
    return this.data.id;
  }

  hide() {
    this.$el.removeClass('current-media').css('opacity', 0);
    if (this.data.isVideo) {
      const playerId = this.$el.attr('id');
      const id = this.data.id;
      const height = this.$el.height();
      this.$el.replaceWith(
        `<div id="${playerId}" class='video-player' data-id="${id}" style="height: ${height}px"></div>`
      );
      this.$el = $(`#${this.data.playerId}`);
    }
  }

  onPlayerReady(event) {
    if (this.autoSlideShow && this.autoSlideShow.isEnabled()) {
      event.target.mute();
    }
    event.target.playVideo();
  }

  onPlayerStateChange(event) {
    switch (event.data) {
      case window.YT.PlayerState.PAUSED:
        if (this.autoSlideShow) {
          this.autoSlideShow.disable();
        }
        break;
      case window.YT.PlayerState.ENDED:
        if (this.autoSlideShow && this.autoSlideShow.isEnabled()) {
          this.autoSlideShow.start();
        }
        break;
      default:
        break;
    }
  }

  show() {
    this.$el
      .addClass('current-media')
      .css('display', 'block')
      .css('opacity', 1);
    if (this.data.isVideo) {
      if (this.data.provider === 'YOUTUBE') {
        this.videoPlayer = new window.YT.Player(this.data.playerId, {
          height: this.$wrapperEl.height(),
          width: this.$wrapperEl.width(),
          videoId: this.data.url,
          playerVars: {
            rel: 0,
            showinfo: 0,
          },
          events: {
            onReady: this.onPlayerReady,
            onStateChange: this.onPlayerStateChange,
          },
        });
        this.$el = $(`#${this.data.playerId}`);
      }
    }
  }

  load() {
    if (this.$el.attr('data-loaded') === 'true') {
      //The image has already been loaded
      return this;
    }
    if (!this.$el || !this.$el[0]) {
      return undefined;
    }

    this.$el[0].onload = () => {
      this.$el.css({
        filter: 'blur(0px)',
        '-webkit-filter': 'blur(0px)',
      });
      this.$el.attr('data-loaded', 'true');
    };
    this.$el.attr('src', this.$el.attr('data-original-img'));
    return this;
  }

  /*
  ZOOM FUNCTIONS
  */
  setUpZoom() {
    this.zoomScale = 1;
    this.inZoom = false;
    if (!this.$el.attr('data-zoom')) {
      this.$el.css('cursor', '');
      return false;
    }

    this.$el
      .off('mouseenter')
      .off('mousemove')
      .off('mouseleave')
      .on('mouseenter', e => this.startZoom(e))
      .on('mousemove', e => this.continueZoom(e))
      .on('mouseleave', () => this.finishZoom());
    return true;
  }

  startZoom(event) {
    const originalImageWidth = this.$el[0].naturalWidth;
    this.inZoom = true;
    this.$el[0].onload = () => {
      this.zoomScale = this.$el[0].naturalWidth / originalImageWidth;
      this.performZoomOnImage(this.zoomScale, event.offsetX, event.offsetY);
      this.$el.attr('data-zoom-loaded', 'true');
    };
    this.$el.attr('src', this.$el.attr('data-zoom'));
  }

  continueZoom(event) {
    if (!this.inZoom) {
      this.startZoom(event);
    } else {
      if ($(event.target).hasClass('carousel-button')) {
        this.performZoomOnImage(1);
      } else {
        this.$el.css('cursor', 'zoom-in');
        this.performZoomOnImage(this.zoomScale, event.offsetX, event.offsetY);
      }
    }
  }

  finishZoom() {
    this.$el.css('cursor', '');
    this.$el.attr('src', this.$el.attr('data-original-img'));
    this.$el[0].onload = undefined;
    this.performZoomOnImage(1);
    this.inZoom = false;
  }

  performZoomOnImage(scale, x, y) {
    if (x && y) {
      this.$el.css({
        transform: `scale(${scale})`,
        'transform-origin': `${x}px ${y}px`,
      });
    } else {
      this.$el.css({
        transform: `scale(${scale})`,
      });
    }
  }
}

module.exports = Media;
